import { useTranslation } from 'react-i18next';

import { Form, Formik } from 'formik';

import { SingleSelect } from '@/common';
import { FilterModalLayout, FilterPopUpValues } from '@/components/layouts';
import { getActiveStatusFilterOptions } from '@/helpers';
import { OrganizationFilterProps, SelectOptionProps } from '@/types';

export const Filters = ({ onClose, apply, reset, filterByStatus }: OrganizationFilterProps) => {
  const [t] = useTranslation('common');

  return (
    <Formik initialValues={{ filterByStatus: filterByStatus ?? null }} onSubmit={() => undefined}>
      {({ setFieldValue, values }) => (
        <Form>
          <FilterModalLayout
            apply={apply as (values: FilterPopUpValues) => void}
            reset={reset}
            onClose={onClose}
            values={values}>
            <div id='dropdown' className='m-0 w-full'>
              <SingleSelect
                isClearable
                placeholder={t('selectStatus')}
                id='filterByStatus'
                label={t('status')}
                options={getActiveStatusFilterOptions()}
                value={values.filterByStatus}
                handleChange={(value) =>
                  setFieldValue('filterByStatus', value as SelectOptionProps)
                }
              />
            </div>
          </FilterModalLayout>
        </Form>
      )}
    </Formik>
  );
};
